import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";

// Hoisted to module scope so React doesn't see fresh object references on
// every render — prevents framer-motion from re-running its animation
// pipeline unnecessarily.
const INITIAL = { opacity: 0, y: 8 };
const ANIMATE = { opacity: 1, y: 0 };
const EXIT = { opacity: 0, y: -4 };
const TRANSITION = { duration: 0.22, ease: [0.22, 1, 0.36, 1] };

/**
 * Subtle global page-transition wrapper.
 * Fades + slightly lifts each route on entry.
 * Keep timing minimal (~220ms) so the app still feels snappy.
 */
export default function PageTransition({ children }) {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial={INITIAL}
        animate={ANIMATE}
        exit={EXIT}
        transition={TRANSITION}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
